import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Impression, ImpressionsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ImpressionsDataService {

  private uri: string = `${environment.apiUrl}impressions`;
  private cacheKey: string = 'impressions.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getImpression(id: number): Observable<Impression|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getImpressions(parameters: {[param: string]: string | string[]}): Observable<ImpressionsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addImpression(data: Impression): Observable<Impression|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addImpressions(data: Impression[]): Observable<Impression[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateImpression(data: Impression): Observable<Impression|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateImpressions(data: Impression[]): Observable<Impression[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchImpression(data: Impression): Observable<Impression|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchImpressions(data: Impression[]): Observable<Impression[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteImpression(data: Impression): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteImpressions(data: Impression[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((impression) => {
      ids.push(impression.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
